import {
  MW_5_14_0,
  MW_5_15_0,
} from '@rsos/reduxDataStore/src/constants/migrationVersions';

/**
 * Migration function that takes a version number and returns the new state for the release
 * @param {Object} state - state
 * @param {String} reducer - which reducer needs a migration
 * @param {Number} version - version number that maps to the migration version number
 */
export const runMigration = (state, reducer, version) => {
  switch (reducer) {
    case 'geoSelection': {
      if (version === MW_5_14_0) {
        return getStateForMWFiveFourteen(state, reducer);
      }
      return state;
    }
    case 'airAmbulance': {
      if (version === MW_5_15_0) {
        return getStateForMWFiveFifteen(state, reducer);
      }
      return state;
    }
  }
};

function getStateForMWFiveFourteen(state, reducerName) {
  if (reducerName === 'geoSelection') {
    return {
      ...state,
      airAmbulance: { coordinates: null, isClickable: false },
      obliqueImagery: { coordinates: null, isClickable: false },
    };
  }
}
function getStateForMWFiveFifteen(state, reducerName) {
  if (reducerName === 'airAmbulance') {
    return {
      ...state,
      requests: { calls: {}, nonCalls: {} },
      removedAirAmbulances: { calls: {}, nonCalls: {} },
      selectedAirAmbulance: null,
      formPageToShow: null,
      hoveredAirAmbulance: null,
      temporaryLocation: null,
      tentativeETALocation: null,
    };
  }
}
